import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./SignUp.css";
import { Link } from "react-router-dom";
import API_URL from "./Config";

const SignUp = ({ onSignUp, onLogin }) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Add state variables for validation messages
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [rePasswordError, setRePasswordError] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  // const [selectedState, setSelectedState] = useState("Gujarat");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  // State for checking username and email availability
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);
  const [isEmailAvailable, setIsEmailAvailable] = useState(true);

  useEffect(() => {
    const checkUsernameAvailability = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/api/check-username`,
          {
            username,
          }
        );
        setIsUsernameAvailable(response.data.available);
      } catch (error) {
        console.error("Error checking username availability:", error.message);
      }
    };

    if (username) {
      checkUsernameAvailability();
    }
  }, [username]);

  useEffect(() => {
    const checkEmailAvailability = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/api/check-email`,
          {
            email,
          }
        );
        setIsEmailAvailable(response.data.available);
      } catch (error) {
        console.error("Error checking email availability:", error.message);
      }
    };

    if (email) {
      checkEmailAvailability();
    }
  }, [email]);

  const validateInputs = () => {
    let isValid = true;

    if (!name) {
      setNameError("Police station name is required");
      isValid = false;
    } else {
      setNameError("");
    }

    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else {
      setEmailError("");
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      isValid = false;
    }

    if (!username) {
      setUsernameError("Username is required");
      isValid = false;
    } else if (username.includes('@')) {
      setUsernameError("Username cannot contain '@' symbol");
      isValid = false;
    } else {
      setUsernameError("");
    }

    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (!rePassword) {
      setRePasswordError("Please re-enter your password");
      isValid = false;
    } else {
      setRePasswordError("");
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!passwordRegex.test(password)) {
      setPasswordError(
        "Password must contain at least 8 characters, at least one uppercase letter, one lowercase letter, at least one number, and at least one special character"
      );
      isValid = false;
    } else if (password !== rePassword) {
      setRePasswordError("Passwords do not match");
      isValid = false;
    }

    return isValid;
  };

  const handleSignUp = async () => {
    if (!validateInputs() || !isUsernameAvailable || !isEmailAvailable) {
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${API_URL}/api/signup`,
        {
          name,
          email,
          username,
          password,
          language: selectedLanguage,
          state: selectedState,
        }
      );
      setIsLoading(false);
      const { message } = response.data;
      setAlertMessage(message);

      // Save state and language in local storage
      localStorage.setItem("userState", selectedState);
      localStorage.setItem("preferred_language", selectedLanguage);

      onSignUp();
      navigate("/login");
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.status === 409) {
        const message = error.response.data.message;
        console.error("Sign up failed:", message);
        setAlertMessage(message);
      } else if (error.response && error.response.status === 500) {
        const message = error.response.data.message;
        console.error("Internal server error:", message);
        setAlertMessage(message);
      } else {
        console.error("An error occurred during sign up:", error.message);
        setAlertMessage("An error occurred during sign up");
      }
    }
  };


  function handleBack() {
    window.history.back();
  }

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/get_states`);
        if (response.data && Array.isArray(response.data)) {
          // Setting the fetched states into the state
          setStates(response.data);
        } else {
          console.error('Failed to fetch states. Response:', response.data);
        }
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    };

    fetchStates();
  }, []);


  return (
    <div className="signup-container">
      <div className="signup-contant">
        {/* <div className="signup-image">
          <img src="/logo100.png" alt="Logo" className="signup-logo" />
        </div> */}
        <div className="signup">
          <div className="card-body">
            <h3 className="signup-card">Create Account</h3>
            {alertMessage && (
              <div className="alert alert-danger">{alertMessage}</div>
            )}
            <div>
              <form>
                <div className="form-groups">
                  <label className="signup-lable">
                    <span className="text-danger">*</span> Preferred Language
                  </label>
                  <select
                    className="form-control"
                    value={selectedLanguage}
                    onChange={(e) => setSelectedLanguage(e.target.value)}
                  >
                    <option value="en">English</option>
                    <option value="gu">ગુજરાતી (Gujarati)</option>
                  </select>
                </div>
                <div className="form-groups">
                  <label className="signup-lable">
                    <span className="text-danger">*</span> State
                  </label>
                  {/* <select
                    className="form-control"
                    value={selectedState}
                    onChange={(e) => setSelectedState(e.target.value)}
                  >
                    <option value="Andaman and Nicobar">Andaman and Nicobar</option>
                    <option value="Goa">Goa</option>
                    <option value="Gujarat">Gujarat</option>
                  </select> */}

                  <select
                    className="form-control"
                    value={selectedState}
                    onChange={(e) => setSelectedState(e.target.value)}
                  >
                    {/* Map over the states to create <option> elements */}
                    <option value="">Select a state</option>
                    {states.map((state) => (
                      <option key={state.id} value={state.state_name}>
                        {state.state_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-groups">
                  <label className="signup-lable">
                    <span className="text-danger">*</span> Police Station
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter police station"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setNameError("");
                    }}
                  />
                  {nameError && (
                    <div className="text-danger">{nameError}</div>
                  )}
                </div>
                <div className="form-groups">
                  <label className="signup-lable">
                    <span className="text-danger">*</span> Email
                  </label>
                  <div className="email-input-container">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setEmailError("");
                      }}
                    />
                    {email && isEmailAvailable && (
                      <div className="checkmark">&#10004;</div>
                    )}
                  </div>
                  {emailError && (
                    <div className="text-danger">{emailError}</div>
                  )}
                  {!isEmailAvailable && (
                    <div className="text-danger">
                      Email already exists. Try with different email.
                    </div>
                  )}
                </div>
                <div className="form-groups">
                  <label className="signup-lable">
                    <span className="text-danger">*</span> Username
                  </label>
                  <div className="username-input-container">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter username"
                      value={username}
                      onChange={(e) => {
                        setUsername(e.target.value);
                        setUsernameError("");
                      }}
                    />
                    {username && isUsernameAvailable && (
                      <div className="checkmark">&#10004;</div>
                    )}
                  </div>
                  {usernameError && (
                    <div className="text-danger">{usernameError}</div>
                  )}
                  {!isUsernameAvailable && (
                    <div className="text-danger">
                      Username already taken. Please choose another.
                    </div>
                  )}
                </div>
                <div className="form-groups">
                  <label className="signup-lable">
                    <span className="text-danger">*</span> Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError("");
                    }}
                  />
                  {passwordError && (
                    <div className="text-danger">{passwordError}</div>
                  )}
                </div>
                <div className="form-groups">
                  <label className="signup-lable">
                    <span className="text-danger">*</span> Confirm Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Re-enter password"
                    value={rePassword}
                    onChange={(e) => {
                      setRePassword(e.target.value);
                      setRePasswordError("");
                    }}
                  />
                  {rePasswordError && (
                    <div className="text-danger">{rePasswordError}</div>
                  )}
                </div>
                <div className="signup-btn">
                  <button
                    type="button"
                    className="continue"
                    onClick={handleSignUp}
                    disabled={isLoading}
                  >
                    {isLoading ? "Registering..." : "Sign Up"}
                  </button>
                </div>
                <div className="last">
                  <p>
                    Already have an account?{" "}
                    <Link to="/signin" onClick={handleBack}>
                      Sign in
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;